// @flow

// Hard-coded ordering for housing age.
export const HOUSE_ORDER = {
  'Kuthula': 1,  // eslint-disable-line
  'El Roi Baby Home': 2,
  'Toddler': 3,  // eslint-disable-line
  'Toddler Home': 3,
  'Emseni 1': 4,
  'Emseni 2': 5,
  'Emseni 3': 6,
  'Emseni 4': 7,
  'Emseni 5': 8,
  'Emseni 6': 9,
  'Emseni 7': 10,
  'Emseni 8': 11,
  'Emseni 9': 12,
  'Emseni 10': 13,
  'Emseni 11': 14,
  'Emseni 12': 15,
};

// Sorts houses by age. Additional houses not found in the list above are sorted
// to the end. Ties are broken by lexicographical ordering.
export const houseComparator = (h1: string, h2: string) => {
  const order1 = HOUSE_ORDER[h1];
  const order2 = HOUSE_ORDER[h2];
  if (order1 && order2) { return order1 - order2; }
  if (order1 && !order2) { return -1; }
  if (!order1 && order2) { return 1; }
  return h1 === h2 ? 0 : h1 < h2 ? -1 : 1;
};



// WEBPACK FOOTER //
// ./client/src/util/searchUtil.js